import React from 'react';
import { styled } from '@mui/material';
import { Autorenew, OpenInNew } from '@mui/icons-material';
import FindChildCareNCLogo from 'assets/images/FindChildCareNCLogo.png';
import { Colors, Text } from 'library';

const LINK = 'https://findchildcarenc.org/provider_access';

export function NCVacanciesCard() {
    return (
        <Card>
            <LogoBox>
                <Logo src={FindChildCareNCLogo} alt="Find Child Care North Carolina" />
            </LogoBox>
            <TitleRow>
                <Autorenew sx={{ fontSize: 18, color: Colors.darkNavy }} />
                <Text variant="body2" bold color={Colors.darkNavy}>
                    Update Vacancies
                </Text>
            </TitleRow>
            <Text variant="caption" color={Colors.darkNavy}>
                Families are searching for open spots — claim your profile and list your availability so they can find
                you. As enrollment grows, Tandem keeps you staffed.
            </Text>
            <CtaButton href={LINK} target="_blank" rel="noopener noreferrer">
                <Text inline variant="body2" bold color={Colors.white}>
                    Update Now
                </Text>
                <OpenInNew sx={{ fontSize: 16, color: Colors.white }} />
            </CtaButton>
        </Card>
    );
}

const Card = styled('div')({
    margin: '12px 16px',
    padding: 14,
    borderRadius: 12,
    backgroundColor: Colors.lightTurq,
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
    border: `1px solid ${Colors.darkNavy}`,
});

const LogoBox = styled('div')({
    backgroundColor: '#FFFFFF',
    borderRadius: 8,
    padding: '8px 10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf: 'flex-start',
});

const Logo = styled('img')({
    height: 28,
    width: 'auto',
    display: 'block',
});

const TitleRow = styled('div')({
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    marginTop: 2,
});

const CtaButton = styled('a')({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 6,
    backgroundColor: '#7824a2',
    textDecoration: 'none',
    padding: '10px 12px',
    borderRadius: 8,
    marginTop: 2,
    '&:hover': {
        backgroundColor: '#7A36C4',
    },
});
